import Vue from 'vue'
import ElementUI from 'element-ui';// 添加
import 'element-ui/lib/theme-chalk/index.css'; // 添加
import App from './App.vue'
import router from './router'

// import VueScrollTo from 'vue-scrollto';

// Vue.use(VueScrollTo, {
//   container: 'body',
//   duration: 800,
//   easing: 'ease',
//   offset: 0,
//   force: true,
//   cancelable: false,
//   onStart: false,
//   onDone: false,
//   onCancel: false,
//   x: false,
//   y: true
// });

Vue.config.productionTip = false // 添加 取消生产提示
Vue.use(ElementUI);// 添加
window.history.pushState(null, null, document.URL)
window.addEventListener('popstate', function() {
  window.history.pushState(null, null, document.URL)
})
new Vue({
 router,
 render: h => h(App)
}).$mount('#app')
